
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Bookpunetolonavalacab() {



    const cardData =
    {
        keyword: 'Pune to Lonavala Taxi ',
        heading: 'S9 Travels: Pune to Lonavala Taxi ',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable taxi services from Pune to Lonavala. Whether you are planning a weekend getaway, a relaxing retreat, or a nature adventure, our well-maintained fleet and professional drivers ensure a smooth and hassle-free journey. Lonavala is approximately 65 km from Pune, and the journey takes around 1.5 to 2 hours by road. Enjoy a safe, comfortable ride with our top-notch amenities and customer-centric service.',

        top: 'Top Places to Visit in Lonavala with S9 Travels',

"topPlaces": [
    {
        "title": "Lonavala Lake",
        "description": "A serene and scenic spot, Lonavala Lake is perfect for nature lovers and those looking for a peaceful retreat. The lake is surrounded by lush greenery, and it's an ideal place for picnics and short walks, especially during the monsoon season when the surroundings are at their best."
    },
    {
        "title": "Karla Caves",
        "description": "The Karla Caves are ancient Buddhist rock-cut caves located near Lonavala. They are famous for their impressive architecture and historical significance. Visitors can explore the caves, admire the beautiful sculptures, and enjoy panoramic views of the surrounding areas."
    },
    {
        "title": "Bhushi Dam",
        "description": "Bhushi Dam is a popular spot in Lonavala, especially during the monsoon season. The dam is known for its picturesque surroundings, and the water overflow makes it an exciting place to visit. The area around the dam is perfect for a relaxing day out, picnics, and photography."
    },
    {
        "title": "Lion's Point",
        "description": "Lion's Point is one of the best viewpoints in Lonavala, offering breathtaking views of the surrounding hills and valleys. The cool breeze and stunning vistas make it a favorite among tourists. It's an excellent spot for sunset views and photo opportunities."
    },
    {
        "title": "Della Adventure Park",
        "description": "For thrill-seekers, Della Adventure Park in Lonavala offers a range of adventure activities like zip-lining, dirt biking, rock climbing, and much more. The park is one of the largest adventure parks in India and is ideal for families, friends, and corporate groups looking for an exciting experience."
    },
    {
        "title": "Rajmachi Fort",
        "description": "Rajmachi Fort, located around 15 km from Lonavala, is an ancient fort that offers a challenging trek with magnificent views of the surrounding Sahyadri mountains. The fort holds historical significance and is a popular spot for trekking and adventure enthusiasts."
    },
    {
        "title": "Tiger's Leap",
        "description": "Tiger's Leap is a cliff-top with a drop of over 650 meters, offering spectacular views of the surrounding valleys. The name comes from the shape of the rock formation, which resembles a tiger leaping. The viewpoint is perfect for photography and enjoying the natural beauty of Lonavala."
    },
    {
        "title": "Pawna Lake",
        "description": "Pawna Lake is an artificial lake near Lonavala, offering a tranquil environment for picnics, boating, and camping. The lake is surrounded by beautiful hills, making it a popular destination for nature lovers and those looking for a peaceful retreat."
    },
    {
        "title": "Imagicaa Theme Park",
        "description": "Located near Lonavala, Imagicaa is a popular theme park with a variety of rides, attractions, and shows for all ages. It's a great destination for families, offering everything from thrilling roller coasters to water rides, along with a variety of food and entertainment options."
    },
    {
        "title": "Tungarli Lake and Dam",
        "description": "Tungarli Lake, located near Lonavala, is an ideal destination for nature walks and enjoying the scenic views of the surrounding hills. The dam and lake are surrounded by greenery, making it a peaceful spot to relax and enjoy the serene environment."
    }
],

"services": [
  {
    "name": "Pune to Lonavala Taxi",
    "description": "S9 Travels offers comfortable and reliable taxi services for your journey from Pune to Lonavala. Whether you're visiting for a relaxing getaway or a quick trip, enjoy a smooth and hassle-free ride with us. Book your Pune to Lonavala taxi today!"
  },
  {
    "name": "Pune to Lonavala Cab Booking",
    "description": "Booking a cab from Pune to Lonavala is simple with S9 Travels. Whether you prefer to book online or by phone, we provide flexible booking options for your convenience. Make your journey stress-free by booking with us!"
  },
  {
    "name": "Pune to Lonavala Taxi Service",
    "description": "Choose S9 Travels for a professional and dependable taxi service from Pune to Lonavala. Our experienced drivers and well-maintained vehicles guarantee a comfortable and enjoyable journey for you."
  },
  {
    "name": "Pune to Lonavala One-Way Taxi",
    "description": "S9 Travels provides affordable one-way taxi services from Pune to Lonavala. Enjoy a direct, comfortable ride to your destination without the hassle of returning. Book your one-way trip today for a hassle-free journey."
  },
  {
    "name": "Pune to Lonavala Round Trip",
    "description": "For a round trip from Pune to Lonavala, S9 Travels offers flexible and convenient options. We ensure that your journey is comfortable, timely, and stress-free, with professional drivers and quality vehicles."
  },
  {
    "name": "Pune to Lonavala Cab Fare",
    "description": "S9 Travels provides transparent and affordable taxi fares for your Pune to Lonavala trip. We ensure that you get great value for your money without any hidden charges. Contact us for an accurate fare estimate before you book."
  },
  {
    "name": "Pune to Lonavala Car Rental",
    "description": "Looking to rent a car for your trip from Pune to Lonavala? S9 Travels offers flexible car rental services, allowing you to travel at your own pace. Choose from a range of vehicles to suit your preferences and needs."
  },
  {
    "name": "Pune to Lonavala Luxury Taxi",
    "description": "For a luxurious travel experience, S9 Travels offers premium luxury taxi services from Pune to Lonavala. Enjoy enhanced comfort, extra space, and a smooth, stylish ride in our high-end vehicles."
  },
  {
    "name": "Pune to Lonavala Efficient Taxi",
    "description": "S9 Travels provides Efficient Taxi services for those seeking a more budget-friendly option. Share the ride with others and still enjoy a comfortable and convenient taxi service from Pune to Lonavala at an affordable price."
  }
],


"tableData": [
  ["Book Pune To Lonavala Taxi", "Book Pune To Lonavala Cab Booking"],
  ["Book Pune To Lonavala Taxi Service", "Book Pune To Lonavala One-Way Taxi"],
  ["Book Pune To Lonavala Round Trip", "Book Pune To Lonavala Cab Fare"],
  ["Book Pune To Lonavala Car Rental", "Book Pune To Lonavala Luxury Taxi"],
  ["Book Pune To Lonavala Efficient Taxi"]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of being punctual when traveling from Pune to Lonavala. Whether you’re heading for a weekend getaway, sightseeing, or a relaxing retreat, our drivers ensure timely pickups and drop-offs to make your trip hassle-free."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a fleet of well-maintained vehicles designed for comfort. With spacious seating, air conditioning, and ample legroom, our cars ensure a relaxing and smooth journey to Lonavala."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are highly experienced and know the best routes to Lonavala. Their professionalism and dedication to safety make sure you have a comfortable and secure trip. You can rely on them to make your journey as pleasant as possible."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive pricing for your Pune to Lonavala trip. We believe in full transparency, providing a clear breakdown of all charges upfront, so you know exactly what to expect. There are no hidden fees."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. Our vehicles come with modern safety features such as airbags, seat belts, and GPS tracking to ensure that you travel securely and comfortably from Pune to Lonavala."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels operates 24/7, so whether you’re planning an early morning trip or a late-night return from Lonavala, we are here to accommodate your needs. Our customer service team is also available around the clock to assist with bookings or inquiries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Lonavala cab with S9 Travels is quick and simple. You can easily reserve your cab via our website or mobile app, or contact our customer service team for assistance in booking your trip."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you're visiting Lonavala for sightseeing, a family vacation, or a corporate trip, we offer customized travel packages to suit your preferences. Let us know your requirements, and we’ll tailor the experience for you."
  }
]












    }




    const faqData = [
        [
          {
            question: 'How can I book a Pune to Lonavala cab with S9 Travels?',
            answer: 'Booking your cab is easy! You can reserve it online through our website or mobile app, or contact our customer service team for any help with your reservation.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, all our drivers are highly experienced in long-distance travel and are familiar with the best routes to Lonavala, ensuring a smooth, safe, and comfortable ride.',
          },
          {
            question: 'What types of vehicles are available for Pune to Lonavala travel?',
            answer: 'We offer a variety of well-maintained vehicles including sedans, SUVs, and premium cars, all designed for comfort on your journey to Lonavala.',
          },
          {
            question: 'How do I pay for my Pune to Lonavala cab rental?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and online payments via our app, so you can choose the most convenient method for you.',
          },
          {
            question: 'Can I book a round trip from Pune to Lonavala?',
            answer: 'Yes, we offer round-trip services. Just let us know your return details, and we’ll make all the necessary arrangements for a smooth return journey.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any extra charges, such as waiting time or detours, will be clearly communicated to you during the booking process, ensuring transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing in Lonavala?',
            answer: 'Yes, we offer sightseeing tours in Lonavala. Explore popular attractions like Bhushi Dam, Tiger’s Leap, and the Karla Caves with our experienced drivers, who can guide you to the best spots.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Lonavala cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have additional luggage or special requirements, please inform us during the booking process, and we’ll make necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate travel between Pune and Lonavala?',
            answer: 'Yes, we offer corporate travel services for business trips or team outings between Pune and Lonavala. We ensure punctual and professional service for all corporate clients.',
          },
          {
            question: 'Why should I choose S9 Travels for Pune to Lonavala travel?',
            answer: 'With S9 Travels, you can expect a reliable, comfortable, and affordable journey. Our professional drivers, clean and spacious vehicles, and excellent customer service ensure a safe, smooth, and enjoyable trip to Lonavala every time.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Amit Shah',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],  
          text: '“I had a wonderful experience traveling to Lonavala with S9 Travels. The car was clean, comfortable, and well-maintained, and the driver was very courteous and professional. I’ll definitely choose them again for my future trips!”',
        },
        {
          name: 'Mrs. Priya Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],  
          text: '“We booked a family trip to Lonavala with S9 Travels, and it was great! The vehicle was spacious, and the driver was very friendly and knowledgeable about the area. The entire journey was smooth and relaxing. Highly recommended!”',
        },
      ];
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Book Pune To Lonavala Cab",
        "description": "Book Pune To Lonavala taxi services, one-way taxi, round trip, luxury taxi, Efficient Taxi, and car rental with S9 Travels. Choose from affordable Pune to Lonavala cab booking options for a comfortable and safe ride to Lonavala.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
    
      
      
      


    return (
        <div>
           <Helmet>
        <title>Book Pune To Lonavala Cab | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune To Lonavala taxi services, one-way taxi, round trip, luxury taxi, Efficient Taxi, and car rental with S9 Travels. Get the best fares for Pune to Lonavala cab booking, ensuring a safe and comfortable ride." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/7.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bookpunetolonavalacab;